// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { useSelector } from "react-redux";

export const useAllowBackOrder = () => {
    return useSelector((state: ApplicationState) => {
        return getSettingsCollection(state).productSettings.allowBackOrder;
    });
};

export const useNotEnoughRequestedStock = (qtyOrdered: number, qtyOnHand: number | undefined) => {
    if (!qtyOnHand || qtyOnHand === 0) {
        return false;
    }

    return qtyOrdered > qtyOnHand;
};
